
import { getVendorDetail, getVendorLinks } from '../api.js'

import partitions from '../partitions.js'
import vendors from '../vendors.js'

import notifications from '../notifications.js'

const _vars = {
  vendorId: undefined,
  vendorDetailData: undefined,

  vendorFormsLinks: undefined,
}

function _getVendorFormOptionsFromCapability(user) {
  if (user === undefined) {
    return Promise.resolve([])
  }

  let capViewVendorForms = user.getCapability('view_vendor_forms')
  let vendorOptions = capViewVendorForms.getVendorOptions()

  let promiseVendor = vendors.getVendorFromServer()
  let promiseParition = partitions.getPartitionFromServer()
  let promiseFinalOptions = Promise.all([promiseVendor, promiseParition])
    .then(() => {
      return vendorOptions.map(function (option) {
        let vendor = vendors.getVendorSync(option.vendor)
        return {
          label: `${vendor.name} -- ${partitions.getPartitionNameSync(vendor.partition)}`,
          value: option.vendor,
        }
      }).sort((a, b) => a.label.localeCompare(b.label))
    })

  return promiseFinalOptions
}

function _getVendorDetail(vendorId) {
  if (_vars.vendorId !== vendorId) {
    return getVendorDetail(vendorId)
      .then(response => {
        _vars.vendorDetailData = response.data
        return _vars.vendorDetailData
      })
      .catch(error => {
        notifications.pushError('Unable to load vendor data from server.', error)
      })
  }
  return Promise.resolve(_vars.vendorDetailData)
}

function _getVendorLinks() {
  if (_vars.vendorFormsLinks) {
    return Promise.resolve(_vars.vendorFormsLinks)
  }

  return getVendorLinks()
    .then(response => {
      _vars.vendorFormsLinks = response.data
      return _vars.vendorFormsLinks
    })
    .catch(error => {
      notifications.pushError('Unable to load vendor links from server.', error)
    })
}

export default {
  getVendorDetail: _getVendorDetail,
  getVendorLinks: _getVendorLinks,
  getVendorFormOptionsFromCapability: _getVendorFormOptionsFromCapability,
}
